import { render, staticRenderFns } from "./RichTextMod.vue?vue&type=template&id=803e21cc"
import script from "./RichTextMod.vue?vue&type=script&lang=js"
export * from "./RichTextMod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports